module.exports = __webpack_public_path__ + "ffef91f16dea6a6adeb73c3f985b8522.pdf";